var _path, _g, _path2, _circle, _circle2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 716,
    viewBox: "0 0 713 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.808594 508.99C71.6556 385.869 204.541 302.97 356.788 302.97C509.035 302.97 641.92 385.869 712.767 508.99C641.92 632.112 509.035 715.01 356.788 715.01C204.541 715.01 71.6556 632.112 0.808594 508.99Z",
    fill: "url(#paint0_linear_469_991)",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_469_991)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.808593 508.99C71.6556 385.869 204.541 302.97 356.788 302.97C509.035 302.97 641.92 385.869 712.767 508.99C641.92 632.112 509.035 715.01 356.788 715.01C204.541 715.01 71.6556 632.112 0.808593 508.99Z",
    fill: "url(#paint1_radial_469_991)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136 1L253.234 564H459.936L571 1H136Z",
    fill: "url(#paint2_linear_469_991)",
    fillOpacity: 0.3,
    stroke: "url(#paint3_linear_469_991)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 353.306,
    cy: 515.436,
    r: 159.349,
    fill: "url(#paint4_linear_469_991)",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.307,
    cy: 515.436,
    r: 139.534,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeDasharray: "10 10"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_469_991)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 356,
    cy: 512.5,
    rx: 119,
    ry: 118.5,
    fill: "url(#paint5_linear_469_991)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.38,
    cy: 514.216,
    r: 117.58,
    transform: "rotate(-28.612 354.38 514.216)",
    fill: "url(#paint6_radial_469_991)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.814,
    cy: 481.116,
    r: 34.8118,
    transform: "rotate(119.439 323.814 481.116)",
    fill: "url(#paint7_radial_469_991)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_469_991",
    x: 0.808594,
    y: 302.97,
    width: 716.958,
    height: 417.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_469_991"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_469_991"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_469_991",
    x: 236.777,
    y: 394,
    width: 238.223,
    height: 241.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_469_991"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_469_991",
    x1: 148.085,
    y1: 368.158,
    x2: 573.016,
    y2: 696.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F84EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_469_991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367.5 289.5) rotate(91.3352) scale(450.622 3257.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EBFC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_469_991",
    x1: 353.5,
    y1: 1,
    x2: 353.5,
    y2: 564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_469_991",
    x1: 353.5,
    y1: 1,
    x2: 353.5,
    y2: 564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_469_991",
    x1: 353.306,
    y1: 356.087,
    x2: 353.306,
    y2: 674.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_469_991",
    x1: 286.583,
    y1: 601.375,
    x2: 432.143,
    y2: 430.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95F7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0921F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_469_991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(327.434 597.502) rotate(-60.2551) scale(78.9969 106.321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE9E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_469_991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.836 505.774) rotate(-55.1521) scale(45.86 61.7222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3aac449a6a93986795e12fcadfe3729e.svg";
export { ForwardRef as ReactComponent };